/** Cómo se leen las URLs del menú del usuario al decidir si entra a una pantalla (AuthProtected). */

/**
 * Rutas que llevan a otra pantalla: tener la de la izquierda en el menú abre la de la derecha.
 * `/sms-templates` es un redirect a `/sms-campaigns?tab=templates` (el menú de figou, infynit y
 * cheap lo trae así): sin esto, quien sólo tenía Plantillas rebotaba al llegar.
 */
export const RUTAS_QUE_ABREN: Record<string, string> = {
  "/sms-templates": "/sms-campaigns",
}

/**
 * URL del menú → ruta que se compara con el pathname. El pathname nunca trae `?tab=…`, y el menú
 * sí (Plantillas `/sms-campaigns?tab=templates`, Canales `?tab=channels`): comparadas tal cual, un
 * perfil que sólo tenía Plantillas o Canales no entraba a la pantalla que su menú le mostraba.
 */
export function rutaDeMenu(url: string): string {
  const sinQuery = (url || "").split(/[?#]/)[0].trim()
  if (sinQuery === "/" || sinQuery === "") return sinQuery
  return sinQuery.replace(/\/$/, "")
}

/** Forma mínima de un nodo del menú del usuario (`useUser().menu`). */
export interface NodoMenu {
  url?: string
  children?: NodoMenu[]
}

/** Rutas a las que el menú del usuario deja entrar (sin query; incluye RUTAS_QUE_ABREN). */
export function rutasDelMenu(menu: NodoMenu[] | null | undefined): string[] {
  const urls: string[] = []
  const walk = (items: NodoMenu[]) => {
    for (const item of items) {
      if (item.url) {
        const ruta = rutaDeMenu(item.url)
        if (ruta) {
          urls.push(ruta)
          if (RUTAS_QUE_ABREN[ruta]) urls.push(RUTAS_QUE_ABREN[ruta])
        }
      }
      if (Array.isArray(item.children)) walk(item.children)
    }
  }
  if (Array.isArray(menu)) walk(menu)
  return urls
}

/** Rutas de la cuenta: cualquier staff con sesión entra aunque no estén en su menú. */
const RUTAS_DE_LA_CUENTA = ["/perfil"]

/** ¿Se puede entrar a `path` con esas rutas? Igual o sub-ruta (`/empresas/3`); "/" no es prefijo. */
export function rutaPermitida(path: string, rutas: string[]): boolean {
  const ruta = path === "/" ? "/" : path.replace(/\/$/, "")
  if (RUTAS_DE_LA_CUENTA.includes(ruta)) return true
  if (rutas.includes(ruta)) return true
  return rutas.some((u) => u !== "/" && u !== "" && ruta.startsWith(u + "/"))
}
